import { render, staticRenderFns } from "./questionFlash.vue?vue&type=template&id=81e67810&scoped=true"
import script from "./questionFlash.vue?vue&type=script&lang=js"
export * from "./questionFlash.vue?vue&type=script&lang=js"
import style0 from "./questionFlash.vue?vue&type=style&index=0&id=81e67810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e67810",
  null
  
)

export default component.exports